import React, { useMemo, useEffect } from 'react'
import { Container, Button, Label, Checkbox } from '@sencha/ext-modern'
import { useInstData } from 'tyan/public/hooks'
import wsJoyusing from './wsJoyusing'

const JoyusingV1 = props => {
	const { onGetFiles, onClose } = props
	const { setState, me, me: { state: { connected, started } } } = useInstData(null, useMemo(() => ({
		state: {}
	}), []))

	const objJoyusing = wsJoyusing

	const dataURLToFile = (dataURL, filename) => {
		const arr = dataURL.split(','),
			mime = arr[0].match(/:(.*?);/)[1], //mime类型 image/png
			bstr = atob(arr[1]) //base64 解码

		let n = bstr.length,
			u8arr = new Uint8Array(n)

		while (n--) {
			u8arr[n] = bstr.charCodeAt(n)
		}

		return new File([u8arr], filename, { type: mime })
		//return new Blob([a8arr], {type: mime});
	}

	const handlerGetPhoto = () => {
		const photo = document.getElementById('photo')
		if (!photo) return
		objJoyusing.sendMsg("sGetBase64")
	}

	const handlerRotateLeft = () => {
		const photo = document.getElementById('photo')
		if (!photo) return
		objJoyusing.sendMsg("bStartPlayRotate(0)")
	}

	const handlerRotateRight = () => {
		const photo = document.getElementById('photo')
		if (!photo) return
		objJoyusing.sendMsg("bStartPlayRotate(270)")
	}

	const handleChange = (cmp, val) => {
		//console.log('val', val)
		me.isContinuous = !me.isContinuous
	}

	useEffect(() => {
		if (!connected) return

		const updatePhoto = (bstr) => {
			const photo = document.getElementById('photo')
			if (photo) photo.src = "data:image/jpeg;base64," + bstr;
		}
		const start = () => {
			setState({ started: true })
		}

		const getPhoto = (bstr) => {
			//console.log('bstr', bstr)
			// 在这里处理拍照，拍照后显示，成功获取内容后 使用File数组回调onGetFiles，
			// 如: cavas.toBlob(blob => onGetFiles[new File(blob, `${Ext.Date.format(new Date(), 'YmdHisu')}.jpg`)], 'image/jpeg', 0.95)
			const file = dataURLToFile("data:image/jpeg;base64," + bstr, `${Ext.Date.format(new Date(), 'YmdHisu')}.jpg`)
			onGetFiles([file])
			if (!me.isContinuous)
				onClose && onClose()
			else
				Ext.toast('已拍照')
		}

		objJoyusing.register('updatePhoto', updatePhoto)
		objJoyusing.register('getPhoto', getPhoto)
		objJoyusing.register('BeginbStartPlaytrueEndbStartPlay', start)

		objJoyusing.sendMsg("vSetResolution(8)")
		objJoyusing.sendMsg("bStartPlay()")
		//objJoyusing.sendMsg("bSetMode(3)")

		return (() => {
			objJoyusing.unregister('BeginbStartPlaytrueEndbStartPlay', start)
			objJoyusing.unregister('updatePhoto', updatePhoto)
			objJoyusing.unregister('getPhoto', getPhoto)
		})

	}, [connected])

	useEffect(() => {
		wsJoyusing.connect(() => setState({ connected: true }))

		return () => {
			objJoyusing.sendMsg("bStopPlay()")
			objJoyusing.sendMsg("bStopPlay4()")
			objJoyusing.disConnect()
		}
	}, [])

	return <Container margin='0 20 20 20' {...props}>
		{!started && <Label html='正在加载摄像头，请稍等...' />}
		{started && <>
			<div><img style={{ 'max-height': '600px' }} id="photo" alt=''></img></div>
			<Container layout={{ type: "hbox", pack: "start" }} >
				<Checkbox lableWidth='0' boxLabel='连续拍照' boxLabelAlign='before' onChange={handleChange} margin='0 10 0 0' />
				<Button iconCls='x-fa fa-rotate-left' handler={() => handlerRotateLeft()} tooltip='回正' />
				<Button iconCls='x-fa fa-rotate-right' handler={() => handlerRotateRight()} tooltip='翻转' />
				<Button docked='right' iconCls='x-fa fa-camera' handler={() => handlerGetPhoto()} text='拍照' />
			</Container>
		</>}
	</Container>
}

export default JoyusingV1